import { LOCATION_CHANGE } from "connected-react-router";
import { CLEAR_USER_INFO,
  CREATE_USER_FAILURE,
  CREATE_USER_REQUESTED,
  CREATE_USER_SUCCESS,
  FETCH_USERS_BY_ROLE_FAILURE,
  FETCH_USERS_BY_ROLE_REQUESTED,
  FETCH_USERS_BY_ROLE_SUCCESS,
  FETCH_USER_PROFILE_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGIN_USER_REQUESTED,
  LOGIN_USER_SUCCESS,
  SEARCH_USER_BY_KEYWORD_FAILURE,
  SEARCH_USER_BY_KEYWORD_REQUESTED,
  SEARCH_USER_BY_KEYWORD_SUCCESS,
  INVITE_USER_ON_PLATFORM_FAILURE,
  INVITE_USER_ON_PLATFORM_REQUESTED,
  INVITE_USER_ON_PLATFORM_SUCCESS,
  HANDLE_ONBOARDING,
  STORE_USER_INFO,
  UPDATE_USER_PROFILE_SUCCESS,
  CHECK_USER_EXISTS_SUCCESS,
  CHECK_USER_EXISTS_CLEAR_SUCCESS,
  UPDATE_USER_PASSWORD_SUCCESS, UPDATE_USER_PASSWORD_REQUESTED, UPDATE_USER_PASSWORD_FAILURE,
  REQUEST_USER_SUCCESS, REQUEST_USER_REQUESTED, REQUEST_USER_FAILURE } from "../actions/user-action-types";

const initialState = {
  agentsList: [],
  movingPlan: {},
  oldCred: null,
  onboardingStatus: null,
  createUserStatus: "pending",
  fetchUserByRoleStatus: "pending",
  loginStatus: "pending",
  searchUsersStatus: "pending",
  inviteUserStatus: "pending",
  user: null,
  usersByRole: [],
  selectedBemovedPlanIndex: 0,
  fetchUserStatus: "pending",
  isUserExists: null,
  updateUserPassword: "pending",
  requestUser: [],
};

export default function user(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case CLEAR_USER_INFO:
      return {
        ...state,
        movingPlan: {},
        user: null,
        token: null,
      };

    case CREATE_USER_FAILURE:
      return {
        ...state,
        createUserStatus: "failure",
      };

    case CREATE_USER_REQUESTED:
      return {
        ...state,
        createUserStatus: "creating",
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createUserStatus: "success",
        user: {
          ...state.user,
          ...payload,
          isAnonymous: false,
        },
        token: payload.token,
      };

    case LOGIN_USER_FAILURE:
      return {
        ...state,
        loginStatus: "failure",
      };

    case LOGIN_USER_REQUESTED:
      return {
        ...state,
        loginStatus: "logging",
      };

    case LOGIN_USER_SUCCESS: {
      return {
        ...state,
        oldCred: payload.email,
        loginStatus: "success",
        user: payload,
        token: payload.token,
      };
    }

    case FETCH_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        oldCred: payload.email,
        fetchUserStatus: "success",
        user: {
          ...state.user, ...payload, isAnonymous: false,
        },
      };
    }

    case HANDLE_ONBOARDING:
      return {
        ...state,
        onboardingStatus: payload,
      };

    case STORE_USER_INFO:
      return {
        ...state,
        movingPlan: payload.movingPlan,
        user: payload.user,
      };

    case UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
          isAnonymous: false,
        },
      };

    case FETCH_USERS_BY_ROLE_FAILURE:
      return {
        ...state,
        fetchUserByRoleStatus: "failure",
      };

    case FETCH_USERS_BY_ROLE_REQUESTED:
      return {
        ...state,
        fetchUserByRoleStatus: "fetching",
      };

    case FETCH_USERS_BY_ROLE_SUCCESS:
      return {
        ...state,
        fetchUserByRoleStatus: "success",
        usersByRole: payload,
      };

    case SEARCH_USER_BY_KEYWORD_FAILURE:
      return {
        ...state,
        searchUsersStatus: "failure",
      };

    case SEARCH_USER_BY_KEYWORD_REQUESTED:
      return {
        ...state,
        searchUsersStatus: "fetching",
      };

    case SEARCH_USER_BY_KEYWORD_SUCCESS:
      return {
        ...state,
        searchUsersStatus: "success",
        agentsList: payload,
      };

    case INVITE_USER_ON_PLATFORM_FAILURE:
      return {
        ...state,
        inviteUserStatus: "failure",
      };

    case INVITE_USER_ON_PLATFORM_REQUESTED:
      return {
        ...state,
        inviteUserStatus: "fetching",
      };

    case INVITE_USER_ON_PLATFORM_SUCCESS:
      return {
        ...state,
        inviteUserStatus: "success",
      };

    case LOCATION_CHANGE:
      return {
        ...state,
        fetchUserByRoleStatus: "pending",
        searchUsersStatus: "pending",
        inviteUserStatus: "pending",
      };

    case CHECK_USER_EXISTS_SUCCESS:
      return {
        ...state,
        isUserExists: payload,
      };

    case CHECK_USER_EXISTS_CLEAR_SUCCESS:
      return {
        ...state,
        isUserExists: null,
      };
    case UPDATE_USER_PASSWORD_FAILURE:
      return {
        ...state,
        updateUserPassword: "failure",
      };
    case UPDATE_USER_PASSWORD_SUCCESS:
      return {
        ...state, updateUserPassword: "success",
      };
    case UPDATE_USER_PASSWORD_REQUESTED:
      return {
        ...state, updateUserPassword: "requested",
      };
    case REQUEST_USER_FAILURE:
      return {
        ...state,
        requestUser: "failure",
      };

    case REQUEST_USER_REQUESTED:
      return {
        ...state,
        requestUser: "logging",
      };

    case REQUEST_USER_SUCCESS: {
      return {
        ...state,
        requestUser: payload,
      };
    }

    default:
      return state;
  }
}
